import { Component } from '@angular/core';


@Component({
    selector: 'config-error',
    templateUrl: '../directives/ucd-templates/template-fallback.html',
})

export class ConfigErrorComponent {
	refreshBrowser = () => {
        window.sessionStorage.clear();
        window.location.reload(false);
    }
}